// Single place to edit brand name, prices and available departures.
export const BRAND = {
  name: "Altitude Club",
  short: "Altitude",
  tagline: "Club privé d'alertes Business",
};

export const TRIAL_DAYS = 7;

export const PLANS = [
  {
    id: "mensuelle",
    name: "Mensuelle",
    price: "14,90 €",
    period: "/mois",
    billing: "Facturée 14,90 € chaque mois après l'essai.",
  },
  {
    id: "annuelle",
    name: "Annuelle",
    price: "99 €",
    period: "/an",
    billing: "Facturée 99 € en une fois, chaque année après l'essai.",
  },
];

export const PRICING_NOTICE = `${TRIAL_DAYS} jours gratuits, puis ${PLANS[0].price}${PLANS[0].period} ou ${PLANS[1].price}${PLANS[1].period} selon la formule choisie. Renouvellement automatique. Résiliation en ligne.`;

export const PLAN_FEATURES = [
  "Offres Business au départ de Paris-CDG, par e-mail",
  "Toutes les destinations surveillées",
  "Destination de rêve facultative",
  "Réservation directe auprès du vendeur, sans intermédiaire",
];

// Departure airports. Set active: true to open a new airport (must match backend common.AIRPORTS).
export const DEPARTURES = [
  {
    code: "FR",
    name: "France",
    cities: [
      { code: "CDG", name: "Paris", airport: "Paris-Charles de Gaulle (CDG)", active: true },
      { code: "NCE", name: "Nice", airport: "Nice Côte d'Azur (NCE)", active: false },
    ],
  },
];

export const DEFAULT_CITY = "CDG";
export const activeCities = (country) => (DEPARTURES.find((c) => c.code === country)?.cities || []).filter((c) => c.active);

export const findCity = (code) => {
  for (const c of DEPARTURES) {
    const city = c.cities.find((x) => x.code === code);
    if (city) return { ...city, country: c.name };
  }
  return null;
};
